// Параметрическая схема мебели.
// Единицы — сантиметры (как в остальном коде). Толщины панелей — в сантиметрах с дробной частью (1.6 = 16 мм).

// ---------- Толщины ----------
export const T_PANEL = 1.6;   // толщина боковины/крыши/дна/перегородки/полки (ЛДСП 16 мм)
export const T_BACK  = 0.3;   // толщина задней стенки ХДФ (3 мм)
export const T_DOOR  = 1.8;   // толщина фасада МДФ (18 мм)
export const GAP_DOOR = 0.2;  // зазор между накладной дверью и корпусом с каждой стороны

// ---------- Типы наполнения ----------
export const CELL_FILLS = {
  empty:       'empty',
  shelf:       'shelf',        // одна полка посредине ячейки
  shelves:     'shelves',      // несколько полок (count)
  rod:         'rod',          // штанга + опциональная полка сверху
  door:        'door',         // распашная дверь, вкладная или накладная, с навесом L/R
  flap_door:   'flap_door',    // откидная дверь (петли сверху)
  drawer:      'drawer',       // один ящик в ячейку
  drawers:     'drawers',      // стопка ящиков в ячейку (count)
};

// ---------- Создание «пустого» проекта ----------
export function makeSource({
  width = 120, height = 200, depth = 60,
  material = 'mdf', color = 'light_oak',
  type = 'wardrobe',
} = {}) {
  return {
    kind: 'parametric-v1',
    type,
    body: { width, height, depth, material, color, hasBack: true },
    grid: {
      cols: [{ frac: 1 }],               // одна колонка во всю ширину
      rows: [{ frac: 1 }],               // один ряд во всю высоту
    },
    cells: {
      '0,0': { fill: CELL_FILLS.empty },
    },
  };
}

// Ключ ячейки из индексов колонки/ряда
export function cellKey(col, row) { return `${col},${row}`; }

function makeId(prefix) {
  return `${prefix}_${Math.random().toString(36).slice(2, 8)}`;
}

export function makeSourceV2({
  category = 'wardrobe',
  width = 120,
  height = 200,
  depth = 60,
  attributes = {},
} = {}) {
  const rootId = makeId('root');
  const bodyId = makeId('body');
  const baseAttributes = {
    body_color: attributes.body_color || 'light_oak',
    body_material: attributes.body_material || 'mdf',
    texture: attributes.texture || 'default',
    edge_thickness: attributes.edge_thickness || 2,
    ...attributes,
  };

  return {
    kind: 'parametric-v2',
    category,
    id: rootId,
    dimensions: { w: width, h: height, d: depth },
    attributes: baseAttributes,
    required_parts: [],
    optional_parts: [],
    parts: [
      {
        id: bodyId,
        partType: 'body',
        parentId: null,
        localBox: { x: 0, y: 0, z: 0, w: width, h: height, d: depth },
        socketRef: null,
        sockets: [
          { id: 'innerContainer', type: 'innerContainer', x: T_PANEL, y: T_PANEL, w: Math.max(0, width - 2 * T_PANEL), h: Math.max(0, height - 2 * T_PANEL) },
          { id: 'frontPlane', type: 'frontPlane', x: 0, y: 0, w: width, h: height },
          { id: 'rearPlane', type: 'rearPlane', x: 0, y: 0, w: width, h: height },
          { id: 'bottomPlane', type: 'bottomPlane', x: 0, y: Math.max(0, height - T_PANEL), w: width, h: T_PANEL },
          { id: 'wallAnchor', type: 'wallAnchor', x: 0, y: 0, w: width, h: height },
        ],
        attributes: {},
      },
    ],
  };
}

export function isParametricSourceV2(v) {
  return v && typeof v === 'object' && v.kind === 'parametric-v2' && Array.isArray(v.parts);
}

// ---------- Валидатор ----------
export function isParametricSource(v) {
  return (
    (v && typeof v === 'object' && v.kind === 'parametric-v1' && v.body && v.grid && v.cells) ||
    isParametricSourceV2(v)
  );
}
